// extracted by mini-css-extract-plugin
module.exports = {"label-name":"label-name-1af1243ba5fc3c276cbdbfdb6bd2f9da"};